import { delay } from 'redux-saga';
import { call, put, cancel, fork } from 'redux-saga/effects';

import { transformRfq } from 'Utils/transform';

import {
   getDataWithToken,
   postDataWithToken,
   putDataWithToken,
   uploadFile,
   uploadFileWithSyncCalls,
   deleteDataWithToken,
   getDataWithoutToken,

   GROUPS_AND_TRANSPORTERS_URL,
   TRANSPORTERS_URL,
   CREATE_RFQ_URL,
   GET_TRIPS_URL,
   ADD_TRIP_URL,
   GET_RFQS_URL,
   GET_RFQS_CONTRACT_URL,
   UPLOAD_DOCUMENT,
   DISCARD_RFQ_URL,
   DELETE_TRIP_URL,
   RFQ_DETAIL_URL,
   GET_RFQS_CONTRACT_DETAILS_URL,
   COPY_RFQ_URL,
   GET_RFQS_TRANSPORTER_URL,
   RFQ_DETAIL_TRANSPORTER_URL,
   POST_BID_URL,
   GET_TRIPS_TRANSPORTER_URL,
   FETCH_BIDS_URL,
   SEEKER_BIDS_URL,
   UPLOAD_CP_FORM_DATA_URL,
   DOWNLOAD_CP_FORM_DATA_URL,

   DOWNLOAD_RFQ_TEMPALTE_URL,
   UPLOAD_RFQ_URL,
   UPLOAD_TRIPS_URL,
   DOWNLOAD_TRIPS_TEMPLATE_URL,

   GET_QBR_URL,
   SEND_SFTP_URL,
   GET_LOCATIONS_URL,
   AUTO_SUGGEST_LOCATIONS_URL,
   CANCEL_RFQ_URL,

   GET_ALL_SUBPLANTS_URL,
   GET_NETWORK_URL,
   GET_ROUTE_CODE_URL,
   SAVE_ROUTE_CODE_URL,
   EDIT_HEADING_CHARGES_URL,
   ADDED_TRIP_DELETE_URL,
   FETCH_SEEKER_BIDS_URL,
   GET_COURIER_TRIPS_URL,
   POST_COURIER_TRIPS_URL,
   UPLOAD_COURIER_TRIPS_URL,
   DOWNLOAD_COURIER_TRIPS_TEMPLATE_URL,
   COURIER_POST_BID_URL,
   PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE_URL,
   GET_SERVICE_CATEGORY_URL,
   FILE_UPLOAD_POST_API_URL,
   POST_SERVICE_CATEGORY_URL,
   GET_TRANSPORTER_BID_COMMON_CHARGES_URL,
   DOWNLOAD_MULTIMODE_TRIPS_TEMPLATE_URL,
   UPLOAD_MULTIMODE_TRIPS_TEMPLATE_URL,
   DOWNLOAD_AUDIT_TRAIL_FORM_DATA_URL,
   DOWNLOAD_MARKET_SITE_RATE_DIFF_URL,
   GET_LOCATION_WITH_PINCODE_URL,
   DIESEL_PRICE_HIKE_URL,
   SEC_AWL_ADD_TRIP_URL,
   GET_DISPOSAL_MATERIAL_TEMPLATE_URL,
   GET_DISPOSAL_MATERIAL_TRIPS_URL,
   POST_DISPOSAL_MATERIAL_TRIPS_URL,
   UPLOAD_DISPOSAL_MATERILA_URL,
   POST_DISPOSAL_PRODUCT_BID_URL,
   TRANSPORTER_SPECIFIC_CONTRACT_RECORD_URL,
   TRANSPORTER_CONTRACT_RECORDS_URL,
   GET_SAP_ROUTE_CODES_URL,
   CREATE_EVENT_URL,
   GET_RFQ_EVENT_URL,
   CANCEL_EVENT_URL,
   POST_WISHLIST_URL,
   UPDATE_RFQ_LEVEL_VENDOR_BIDDING_STATUS_URL,
   UPLOAD_CONTAINER_TRIPS_URL,
   DOWNLOAD_CONTAINER_TEMPLATE_URL,
   GET_CONTAINER_TRIPS_URL,
   POST_CONTAINER_TRIPS_URL,
   DOWNLOAD_EXTISTING_TRIPS_REMARKS_TEMPLATE_URL,
   UPLOAD_EXTISTING_TRIPS_REMARKS_URL,
   POST_CONTAINER_LPP_URL,
   DOWNLOAD_FILE_URL,
   EXIM_ADD_TRIP_URL,
   GET_EXIM_TRIPS_URL,
   EXIM_EDIT_UPDATE_CHARGES_URL,
   EXIM_POST_BID_URL,
   GET_EXIM_LPP_URL,
   GENERAL_PROCUREMENT_ADD_TRIP_URL,
   GET_PROCUREMENT_TRIPS_URL,
   GET_TERMS_AND_CONDITIONS_URL,
   POST_TOLL_TAX_UPDATE_PRICE_URL,
   GET_DPH_DASHBOARD_LIST_URL,
   GET_DPH_BRANCHES_LIST_URL,
   POST_DPH_SEND_TO_APPROVAL_URL,
   GET_DPH_RFQ_DETAILS_URL,
   POST_DPH_APPROVE_REJECT_PROPOSAL_URL,
   POST_UPDATE_BUSINESS_VOLUME_URL,
   GET_DPH_APPROVER_DETAILS_URL,
   GET_DPH_DOWNLOAD_EXCEL_URL,
   ADMIN_UPDATE_RFQ_URL,
   UPDATE_DPH_CALCULATION_MASTER_URL,
   DOWNLOAD_DPH_CALCULATION_MASTER_URL,
   UPLOAD_DPH_CALCULATION_MASTER_URL
} from 'Utils/api';

import {
   GET_GROUPS_AND_TRANSPORTERS_SUCCESS,
   SET_NEXT_RFQ_VIEW,
   CREATE_RFQ_SUBMITTING,
   CREATE_RFQ_SUCCESS,
   GET_TRIPS_SUCCESS,
   GET_RFQS_ERROR,
   GETTING_RFQS,
   GET_RFQS_SUCCESS,
   GET_RFQ_TRIPS_SUCCESS,
   CLEAR_RFQS,
   CLEAR_TRIPS,
   UPLOAD_DOCUMENT_SUBMITTING,
   UPLOAD_DOCUMENT_SUCCESS,
   UPLOAD_DOCUMENT_FAIL,
   ADD_TRIP_ADDING,
   ADD_TRIP_SUBMITTING,
   ADD_TRIP_SUCCESS,

   GET_TRIPS_LOADING,
   GET_RFQ_DETAIL_SUCCESS,
   POST_BID_SUBMITTING,
   TOAST_ERROR,
   FETCH_BIDS_SUBMITTING,
   FETCH_BIDS_SUCCESS,
   TOAST_SUCCESS,

   FETCH_SEEKER_BIDS_SUBMITTING,
   FETCH_SEEKER_BIDS_SUCCESS,

   DOWNLOAD_RFQ_TEMPLATE_SUBMITTING,
   DOWNLOAD_RFQ_TEMPLATE_SUCCESS,

   UPLOAD_RFQ_SUBMITTING,
   UPLOAD_RFQ_SUCCESS,

   UPLOAD_TRIPS_SUBMITTING,
   UPLOAD_TRIPS_SUCCESS,

   GET_QBR_SUCCESS,

   SET_SYSTEM_TIME,
   ALL_LOCATIONS_LIST,
   AUTO_SUGGEST_LOCATIONS_DATA,

   GET_ALL_SUBPLANTS_DATA,
   SAVE_NETWORK_DETAILS,
   DELETE_ADDED_TRIP_START,
   DELETE_ADDED_TRIP_END,
   GET_COURIER_TRIPS_SUCCESS,
   GET_COURIER_TRIPS_START,
   POST_COURIER_TRIPS_END,
   GET_SERVICE_CATEGORY_END,
   GET_SERVICE_CATEGORY_START,
   SAVE_SERVICE_CATEGORY,
   GET_TRANSPORTER_BID_COMMON_CHARGES_CLEAR,
   SAVE_TRANSPORTER_BID_COMMON_CHARGES,
   GET_TRANSPORTER_BID_COMMON_CHARGES_SUCCESS,
   GET_TRANSPORTERS_LIST_SUCCESS,
   END_LOADER,
   START_LOADER,
   ADMIN_UPDATE_RFQ,
   ADMIN_UPDATE_RFQ_SUCCESS,
   UPDATE_DPH_CALCULATION_MASTER,
   DOWNLOAD_DPH_CALCULATION_MASTER,
   UPLOAD_DPH_CALCULATION_MASTER
} from 'Constants/actionConstants';

import Group from 'Models/Group';
import Transporter from 'Models/Transporter';
import Trip from 'Models/Trip';
import { TRANSPORTER } from 'Constants/commonConstants';
import Bid from '../models/Bid';
import Rule from 'Models/Rule';
import CourierTrip from 'Models/CourierTrip';
import { isAdaniWilmar,downloadUrl, isRILCompany } from 'Utils/index';
import { getUser } from 'Utils/storage';
import { getPresignedUrl } from './common';

export function* getTransportersList(action) {
   try {
      const response = yield call(getDataWithToken, TRANSPORTERS_URL, action.params);
      const transporters = response.data.list.map((transporter) => {
         return new Transporter(transporter);
      });
      yield put({
         type: GET_TRANSPORTERS_LIST_SUCCESS,
         transporters
      });
   } catch (e) {
      console.log('ERROR', e);
   }
}

export function* getGroupsAndTransporters(action) {
   try {
      const data = yield call(getDataWithToken, GROUPS_AND_TRANSPORTERS_URL, action.params);
      if (data.data && data.data.groups) {
         const groups = data.data.groups.map((group) => {
            return new Group(group);
         });
         const transporters = data.data.transporters.map((transporter) => {
            return new Transporter(transporter);
         })
         yield put({
            type: GET_GROUPS_AND_TRANSPORTERS_SUCCESS,
            groups,
            transporters
         })
      }
      if(action.onSuccess) {
         action.onSuccess();
      }
   } catch (e) {
      console.log('ERROR', e);
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}
export function* createFreshRFQ(action) {
   try {
      yield put({
         type: CREATE_RFQ_SUBMITTING
      });
      const data = yield call(postDataWithToken, CREATE_RFQ_URL, action.rfq);
      const rfq = transformRfq(data.data);
      localStorage.setItem('teg-component', true);
      if([12,13,14,15].includes(rfq.type)) {
         location.href = "/exim/rfq/create/" + rfq.id + "/" + rfq.type;
      } else {
         if(!!action.isNewScreenRoute){
            location.href = "/nsr/create-rfq/" + rfq.id + "/" + rfq.type;
         }else{
            location.href = "/rfq/create/" + rfq.id + "/" + rfq.type;
         }
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}
export function* createRFQ(action) {
   try {
      yield put({
         type: CREATE_RFQ_SUBMITTING
      });
      const data = yield call(postDataWithToken, CREATE_RFQ_URL, action.data);
      if (action.data.is_draft === false || action.saveAndClose) {
         yield put({
            type: TOAST_SUCCESS,
            message: action.saveAndClose ? "RFQ Saved Successfully" : "RFQ Created Successfully"
         });
         yield put({
            type: CREATE_RFQ_SUCCESS,
            rfq: action.rfq
         });
         if(action.onSuccess) {
            action.onSuccess();
         }
         if(!isRILCompany(action.rfq.companyId)){
            location.href = "/";
         }
      } else {
         if(action.onSuccess) {
            action.onSuccess();
         }
         if (action.nextView !== false) {
            yield put({
               type: SET_NEXT_RFQ_VIEW
            });
         }
         if (data.data && data.data.rfq_id && action.rfq) {
            action.rfq.setId(data.data.rfq_id);
         }
         yield put({
            type: CREATE_RFQ_SUCCESS,
            rfq: action.rfq
         });
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
      yield put({
         type: CREATE_RFQ_SUCCESS,
         rfq: action.rfq
      });
      console.log('ERROR', e);
   }
}
export function* discardfRfq(action) {
   try {
      yield put({
         type: CREATE_RFQ_SUBMITTING
      });

      const data = yield call(deleteDataWithToken, DISCARD_RFQ_URL, action.data);
      yield put({
         type: TOAST_SUCCESS,
         message: "RFQ Discarded Successfully"
      });
      location.href = "/";

   } catch (e) {
      console.log('ERROR', e);
   }
}
export function* getTrips(action) {
   try {
      const { whoami, rfqType } = action.params;
      const url = getTripsUrl(whoami, rfqType);
      if (whoami !== TRANSPORTER) {
         yield put({
            type: CLEAR_TRIPS
         });
      }
      if (!action.params.isFirstLoad) {
         yield delay(1000);
      }
      const data = yield call(getDataWithToken, url, action.params);
      if (data.data && (data.data.list || data.data.product_disposal_list || data.data.procurement_list)) {
         const trips = (data.data.list || []).map((trip) => {
            return new Trip(trip);
         });
         yield put({
            type: GET_TRIPS_SUCCESS,
            trips: (rfqType == 9 && (whoami && whoami === TRANSPORTER)) ? data.data.disposal_product_list : (data.data.product_disposal_list || trips),
            tripsCount: (data.data.procurement_list || []).length > 0 ? data.data.actuall_trips_count : data.data.trips_count,
            otherCharges: data && data.data && data.data.other_charges_list || [],
            slabList: data.data && data.data.slab_list || [],
            additionalZoneList: data.data && (data.data.additional_zone_list || []).map((trip)=> {
               return new Trip(trip);
            }) || [],
            fromZones: data.data && (data.data.zone_from_list || []).map(zone => { return { name: zone, value: zone }}) || [],
            toZones: data.data && (data.data.zone_to_list || []).map(zone => { return { name: zone, value: zone }}) || [],
            tZones: data.data && (data.data.t_zone_list || []).map(zone => { return { name: zone, value: zone }}) || [],
            plantNames: data.data && (data.data.plant_name_list || []).map(zone => { return { name: zone, value: zone }}) || [],
            materials: data.data && (data.data.material_list || []).map(zone => { return { name: zone, value: zone }}) || [],
            distNames: data.data && (data.data.dist_list || []).map(zone => { return { name: zone, value: zone }}) || [],
            totalValueVisibilityOnProvider: data.data.total_value_visibility_on_provider || false,
            totalValueVisibilityOfL1OnProvider: data.data.total_value_visibility_of_L1_on_provider || false,
            visibilityOfLotRankingForProvider: data.data.visibility_of_lot_ranking_for_provider || false,
            chatBoxEnable: data.data.chatBoxEnable || false,
            maxCountToWithdrawBid: data.data.maxCountToWithdrawBid || '',
            totalBidExtension: data.data.totalBidExtension || '',
            allowTransporterToAddCostHeadDuringBidding: data.data.allow_transporter_to_add_cost_head_during_bidding,
            transporterBiddedCount: data.data.transporter_bidded_count,
            procurementList: data.data && data.data.procurement_list || [],
            termsAccepted: data.data && data.data.terms_accepted || false
         });
      }
      yield put({
         type: SET_SYSTEM_TIME,
         data: data.system_time
      })
      if (action.onSuccess) {
         action.onSuccess(data.data);
      }
   } catch (e) {
      yield put({
         type: GET_TRIPS_SUCCESS,
         trips: [],
         tripsCount: 0
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
      if (action.onError) {
         action.onError(e)
      }
      console.log('ERROR', e);
   }
}
export function* addTrip(action) {
   try {
      yield put({
         type: ADD_TRIP_SUBMITTING
      });
      const url = getAddTripUrl(action.params.rfqType);
      const data = yield call(postDataWithToken, url, action.data, action.additionalParams);
      yield call(getTrips, { params: action.params });
      yield put({
         type: ADD_TRIP_ADDING,
         addingTrip: false
      });
      yield put({
         type: ADD_TRIP_SUCCESS
      });
      yield delay(10);
      if (action.saveAndKeepAdding) {
         yield put({
            type: ADD_TRIP_ADDING,
            saveAndKeepAdding: action.saveAndKeepAdding,
            addingTrip: true
         });
      }
      if (action.onSuccess) {
         action.onSuccess(data.data);
      }
   } catch (e) {
      if (action.onError) {
         action.onError(e)
      }
      yield put({
         type: ADD_TRIP_SUCCESS
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });

   }
}
export function* deleteTrip(action) {
   try {
      yield put({
         type: ADD_TRIP_SUBMITTING
      });
      const data = yield call(deleteDataWithToken, DELETE_TRIP_URL, action.data);
      yield call(getTrips, { params: action.params });
      yield put({
         type: ADD_TRIP_ADDING,
         addingTrip: false
      });
      yield put({
         type: ADD_TRIP_ADDING,
         addingTrip: false
      });
      yield put({
         type: ADD_TRIP_SUCCESS,
         addingTrip: false
      });

   } catch (e) {
      console.log('ERROR', e);
      yield put({
         type: ADD_TRIP_SUCCESS,
         addingTrip: false
      });
   }
}
export function* uploadDocument(action) {
   try {
      yield put({ type: START_LOADER });
      if(!action.noSaveUpload) {
         yield put({
            type: UPLOAD_DOCUMENT_SUBMITTING,
         });
      }
      const data = yield call(uploadFile, UPLOAD_DOCUMENT, action.file);
      // const presignedUrlData = yield call(getPresignedUrl, {
      //    data,
      // });
      if(!action.noSaveUpload) {
         yield put({
            type: UPLOAD_DOCUMENT_SUCCESS,
            document: data
         });
      }
      yield put({ type: END_LOADER });
      yield put({
         type: TOAST_SUCCESS,
         message: data?.message || 'Document uploaded successfully',
      });
      if (action.onSuccess) {
         action.onSuccess(data);
      }
   } catch (e) {
      yield put({ type: END_LOADER });
      yield put({ type: UPLOAD_DOCUMENT_FAIL });
      yield put({
         type: TOAST_ERROR,
         message: e?.message || 'Failed to upload document',
      });
      console.log('ERROR', e);
   }
}
export function* getContractedRfqs(action) {
   try {
      yield put({
         type: GETTING_RFQS
      });
      const url = action.isTransporter ? TRANSPORTER_CONTRACT_RECORDS_URL : GET_RFQS_CONTRACT_URL;
      const response = yield call(getDataWithToken, url, action.params);
      yield put({
         type: SET_SYSTEM_TIME,
         data: response.system_time
      });
      yield put({
         type: GET_RFQS_SUCCESS,
         data: {
            list: (response.data.list || []).map((rfq) => transformRfq(rfq)),
         }
      });
      if (action.onSuccess) {
         action.onSuccess(response.data);
      }
   } catch (e) {
      console.log('ERROR', e);
   }
}
export function* getContractedRfqDetails(action) {
   try {
      yield put({
         type: GETTING_RFQS
      });
      const url = action.isTransporter ? TRANSPORTER_SPECIFIC_CONTRACT_RECORD_URL : GET_RFQS_CONTRACT_DETAILS_URL;
      const response = yield call(getDataWithToken, url, action.params);
      const rfqDetails = response.data.rfq;

      yield put({
         type: SET_SYSTEM_TIME,
         data: response.system_time
      });
      yield put({
         type: GET_RFQ_TRIPS_SUCCESS,
         data: {
            list: (response.data.list.bids || []),
            rfqDetails,
         }
      });
      if (action.onSuccess) {
         action.onSuccess(response.data);
      }
   } catch (e) {
      console.log('ERROR', e);
   }
}
export function* getContractedRfqsBetweenDates(action) {
   try {
      yield put({
         type: GETTING_RFQS
      });
      const url = action.isTransporter ? TRANSPORTER_CONTRACT_RECORDS_URL : GET_RFQS_CONTRACT_URL;
      const response = yield call(getDataWithToken, url, action.params);
      yield put({
         type: SET_SYSTEM_TIME,
         data: response.system_time
      });
      yield put({
         type: GET_RFQS_SUCCESS,
         data: {
            list: (response.data.list || []).map((rfq) => transformRfq(rfq)),
         }
      });
      if (action.onSuccess) {
         action.onSuccess(response.data);
      }
   } catch (e) {
      console.log('ERROR', e);
      yield put({
         type: GET_RFQS_SUCCESS,
         data: {
            list: [],
         }
      });
   }
}
export function* getRfqs(action) {
   const { type, limit, offset, search, whoami, from, to, rfqType, isSpotContract, branchId, rfqActiveStatus, biddingType, user, contractType, seekerCompanyId, loiStatus, cpStatus, boundType } = action.params;
   const url = whoami && whoami === TRANSPORTER ? GET_RFQS_TRANSPORTER_URL : GET_RFQS_URL;
   try {
      yield put({
         type: GETTING_RFQS
      });
      const response = yield call(getDataWithToken, url, {
         type: type,
         limit: limit,
         offset: offset,
         search: search,
         from:from,
         to:to,
         rfqType,
         isSpotContract,
         branchId,
         rfqActiveStatus,
         biddingType,
         user,
         contractType,
         seekerCompanyId,
         loiStatus,
         cpStatus,
         boundType
      });
      yield put({
         type: SET_SYSTEM_TIME,
         data: response.system_time
      });
      yield put({
         type: GET_RFQS_SUCCESS,
         data: {
            list: (response.data.list || []).map((rfq) => transformRfq(rfq)),
            activeCount: response.data.active_count,
            biddingCount: response.data.bidding_count,
            closePendingCount: response.data.rfq_Colse_Pending_Count,
            loiCount: response.data.loi_count,
            rfqApprovedCount: response.data.rfq_Approved_Count,
            rfqApproverPendingCount: response.data.rfq_Approver_Pending_Count,
            rfqApproverApproved:response.data.rfq_approver_approved,
            loi_contract_count: response.data.loi_contract_count,
            user_name_list: response.data.user_name_list || []
         }

      });
      if (action.onSuccess) {
         action.onSuccess();
      }
   } catch (e) {
      console.log('ERROR', e);
      yield put({
         type: GET_RFQS_ERROR,
         error: ''
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
      if (action.onError) {
         action.onError(e);
      }
   }
}
export function* getRFQDetail(action) {
   try {
      const { rfqId, whoami, rfqType, seekerCompanyId } = action.params;
      const url = whoami && whoami === TRANSPORTER ? RFQ_DETAIL_TRANSPORTER_URL : RFQ_DETAIL_URL;
      const data = yield call(getDataWithToken, url, {
         rfqId: rfqId,
         rfqType: rfqType,
         seekerCompanyId: seekerCompanyId
      });
      yield put({
         type: SET_SYSTEM_TIME,
         data: data.system_time
      });
      const rfq = transformRfq(data.data);
      if(action.onSuccess) {
         action.onSuccess(rfq);
      }
      yield put({
         type: GET_RFQ_DETAIL_SUCCESS,
         rfq
      });
   } catch (e) {
      yield put({
         type: GET_RFQ_DETAIL_SUCCESS,
         rfq: null
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
      if (action.onError) {
         action.onError(e);
      }
   }
}
export function* copyRfq(action) {
   try {
      yield put({
         type: CREATE_RFQ_SUBMITTING
      });
      const data = yield call(postDataWithToken, COPY_RFQ_URL, action.params);
      const rfq = transformRfq(data.data);
      localStorage.setItem('teg-component', true);
      if([12,13,14,15].includes(rfq.type)) {
         location.href = "/exim/rfq/create/" + rfq.id + "/" + rfq.type + "/copy";
      } else {
         if(!!action.isNewScreenRoute){
            location.href = "/nsr/create-rfq/" + rfq.id + "/" + rfq.type + "/copy";
         }else{
            location.href = "/rfq/create/" + rfq.id + "/" + rfq.type + "/copy";
         }
      }
   } catch (e) {
      console.log('ERROR', e);

   }
}
export function* postBid(action) {
   try {
      yield put({
         type: POST_BID_SUBMITTING
      });
      // const url = (action.params || {}).rfqType === 9 ? POST_DISPOSAL_PRODUCT_BID_URL : POST_BID_URL;
      const url = getPostBidUrl((action.params || {}).rfqType);
      const data = yield call(postDataWithToken, url, action.params);
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Bid Posted Successfully!"
      });
      if (action.onSuccess) {
         action.onSuccess(data.data);
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         duration: 6,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* fetchBids(action) {
   
   const { whoami } = action.params;
      const url = whoami && whoami === TRANSPORTER ? FETCH_BIDS_URL : FETCH_SEEKER_BIDS_URL;
   try {
      yield put({
         type: FETCH_BIDS_SUBMITTING
      });
      const data = yield call(getDataWithToken, url, action.params);
      const transFormedData = {
         bids: data.data.list.map((bid) => new Bid(bid)),
         rules: data.data.rules_list.map((rule) => new Rule(rule)),
         pricingBasis: data.data.pricing_basis
      }
      yield put({
         type: FETCH_BIDS_SUCCESS,
         transFormedData
      });
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
      yield put({
         type: FETCH_BIDS_SUCCESS
      });
      if (action.onError) {
         action.onError(e);
      }
   }
}
export function* fetchSeekerBids(action) {
   try {
      // yield put({
      //     type: FETCH_SEEKER_BIDS_SUBMITTING
      // });
      const data = yield call(getDataWithToken, SEEKER_BIDS_URL, action.params);
      // let fromZones = [];
      // let toZones = [];
      const rawRfq = data.data.rfq;
      rawRfq.list = data.data.list;
      rawRfq.additionalZones = data.data && data.data.additional_zone_list || [];
      rawRfq.otherCharges = data.data && data.data.other_charges_list || [];
      const rfq = transformRfq(rawRfq);
      // if(rfq.type === 4) {
      //    fromZones =  rfq.trips.map(trip => trip.zoneName || trip.additionalZoneFrom).filter((value, index, self) => self.indexOf(value) === index);
      //    toZones = rfq.trips.map(trip => (trip.zone && trip.zone.zone_to) || trip.additionalZoneTo).filter((value, index, self) => self.indexOf(value) === index);
      // }
      yield put({
         type: SET_SYSTEM_TIME,
         data: data.system_time
      });
      yield put({
         type: FETCH_SEEKER_BIDS_SUCCESS,
         rfq,
         tripsCount: data.data.trips_count,
         approverMessage: data.data.approver_message,
         slabList: data.data && data.data.slab_list || [],
         maxTransportersCountRFQ: data.data && data.data.maxTransportersCountRFQ,
         bided_transporter_name: data.data && data.data.bided_transporter_name || [],
         fromZones: data.data && (data.data.zone_from_list || []).map(zone => { return { name: zone, value: zone }}) || [],
         toZones: data.data && (data.data.zone_to_list || []).map(zone => { return { name: zone, value: zone }}) || [],
         chat_menu: (data.data || {}).chat_menu
      });
      if (action.onSuccess) {
         action.onSuccess(data.data);
      }
   } catch (e) {
      console.log('ERROR');
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
      if (action.onError) {
         action.onError(e)
      }
   }
}
export function* getRFQDownloadTemplate(action) {
   try {
      yield put({
         type: DOWNLOAD_RFQ_TEMPLATE_SUBMITTING
      });
      const data = yield call(getDataWithToken, DOWNLOAD_RFQ_TEMPALTE_URL, action.params);
      const presignedUrlData = yield call(getPresignedUrl, {
         data,
      });
      yield put({
         type: DOWNLOAD_RFQ_TEMPLATE_SUCCESS,
         url: presignedUrlData.url
      });
      if (action.onSuccess) {
         action.onSuccess(presignedUrlData);
      }
   } catch (e) {
      yield put({
         type: DOWNLOAD_RFQ_TEMPLATE_SUCCESS,
         url: '/'
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}
export function* uploadRFQ(action) {
   try {
      yield put({
         type: UPLOAD_RFQ_SUBMITTING
      });
      // const data = yield call(uploadFileWithSyncCalls, UPLOAD_RFQ_URL, action.file, action.params);
      const data = yield call(uploadFileWithSyncCalls, FILE_UPLOAD_POST_API_URL, action.file, action.params )
      yield put({
         type: UPLOAD_RFQ_SUCCESS
      });
      yield put({
         type: TOAST_SUCCESS,
         message: "RFQ Uploaded Successfully"
      });
      if (action.onSuccess) {
         action.onSuccess(data.data);
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}
export function* getTripsDownloadTemplate(action) {
   try {
      // yield put({
      //     type: DOWNLOAD_RFQ_TEMPLATE_SUBMITTING
      // });
      const url = action.params && action.params.type === 1 ? DOWNLOAD_COURIER_TRIPS_TEMPLATE_URL :action.params.type === 3 ? DOWNLOAD_MULTIMODE_TRIPS_TEMPLATE_URL : action.params.rfqType == 9 ? GET_DISPOSAL_MATERIAL_TEMPLATE_URL : DOWNLOAD_TRIPS_TEMPLATE_URL;
      if(action.params.rfqType == 9) {
         action.params.type = 1;
      }
      const data = yield call(getDataWithToken, url, action.params);
      // yield put({
      //     type: DOWNLOAD_RFQ_TEMPLATE_SUCCESS,
      //     url: data.data.link
      // });
      const presignedUrlData = yield call(getPresignedUrl, {
         data
      });
      if (action.onSuccess) {
         action.onSuccess(presignedUrlData);
      }
   } catch (e) {
      yield put({
         type: DOWNLOAD_RFQ_TEMPLATE_SUCCESS,
         url: '/'
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}
export function* getProviderServiceCategoryDownloadTemplate(action) {
	try {
		
		const url = PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE_URL;
		const data = yield call(getDataWithToken, url, action.params);
		const presignedUrlData = yield call(getPresignedUrl, {
         data,
      });
		if (action.onSuccess) {
			action.onSuccess(presignedUrlData);
		}
	} catch (e) {
		yield put({
			type: PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE,
			url: '/'
		});
		yield put({
			type: TOAST_ERROR,
			message: e && e.message ? e.message : "Oops! Something Went Wrong"
		});
	}
}


export function* uploadTrips(action) {
   try {
      yield put({
         type: UPLOAD_TRIPS_SUBMITTING
      });
      // const url = action.params && action.params.type === 1 ?  UPLOAD_COURIER_TRIPS_URL : UPLOAD_TRIPS_URL;
      const url = action.params && action.params.type === 1 ?  UPLOAD_COURIER_TRIPS_URL : action.params.type === 3 ? UPLOAD_MULTIMODE_TRIPS_TEMPLATE_URL : (action.params.rfqType == 9 ? UPLOAD_DISPOSAL_MATERILA_URL : FILE_UPLOAD_POST_API_URL);

      const data = yield call(uploadFileWithSyncCalls, url, action.file, action.params);
      yield put({
         type: UPLOAD_TRIPS_SUCCESS
      });
      yield put({
         type: TOAST_SUCCESS,
         message: data.message
      });
      if (action.onSuccess) {
         action.onSuccess(data.data);
      }
   } catch (e) {
      yield put({
         type: UPLOAD_TRIPS_SUCCESS
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}
export function* getQBR(action) {
   try {
      const data = yield call(getDataWithToken, GET_QBR_URL, action.params);
      yield put({
         type: GET_QBR_SUCCESS,
         abr: data.data.qbr
      });
      if (action.onSuccess) {
         action.onSuccess(data.data);
      }
   } catch (e) {
   }
}
export function* cancelSagas(action) {
   console.log('CANCEL TIMERS');
   try {
      const bgSyncTask = yield fork(getTrips)
      yield cancel(bgSyncTask);
      // yield cancel(getTrips);
   } catch (e) {
   }
}

export function* sendSFTP(action) {
   try {
      const data = yield call(postDataWithToken, SEND_SFTP_URL, action.data);
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Oops! Something Went Wrong"
      });
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* getAllLocations(action) {
   try {
      const data = yield call(getDataWithToken, GET_LOCATIONS_URL, action.data);
      yield put({
         type: ALL_LOCATIONS_LIST,
         data: data.data
      });
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* getAutoSuggestLocations(action) {
   try {
      const data = yield call(getDataWithToken, AUTO_SUGGEST_LOCATIONS_URL, action.data);
      yield put({
         type: AUTO_SUGGEST_LOCATIONS_DATA,
         data: data.data
      })
      if (action.onSuccess) {
         action.onSuccess(data.data);
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* uploadCPFormInfo(action) {
   try {
      const data = yield call(uploadFile, UPLOAD_CP_FORM_DATA_URL, action.file, action.data);
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Uploaded file Successfully!"
      })
      if (action.onSuccess) {
         action.onSuccess(data.data);
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* downloadCPFormInfo(action) {
   try {
      const data = yield call(getDataWithToken, DOWNLOAD_CP_FORM_DATA_URL, action.data);
      const presignedUrlData = yield call(getPresignedUrl, {
         data,
      });
      if (action.onSuccess) {
         action.onSuccess(presignedUrlData);
      }
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Downloaded File Successfully!"
      });
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* postCancelRFQ(action) {
   try {
      const data = yield call(putDataWithToken, CANCEL_RFQ_URL, action.data);
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "RFQ Cancelled Successfully!"
      });
      if (action.onSuccess) {
         action.onSuccess(data);
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* getAllSubPlants(action) {
   try {
      const data = yield call(getDataWithToken, GET_ALL_SUBPLANTS_URL, action.params);
      yield put({
         type: GET_ALL_SUBPLANTS_DATA,
         data: data.data
      })
      if (action.onSuccess) {
         action.onSuccess(data);
      }
   } catch (e) {
      if (action.onError) {
         action.onError(e)
      }
   }
}

export function* getNetworkDetails(action) {
   try {
      const data = yield call(getDataWithToken, GET_NETWORK_URL, action.param);
      yield put({
         type: SAVE_NETWORK_DETAILS,
         data: data.data && data.data.list ? data.data.list : []
      })
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}
export function* getRouteCode(action) {
   try {
      const data = yield call(getDataWithToken, GET_ROUTE_CODE_URL, action.data);
      if (action.onSuccess) {
         action.onSuccess(data && data.data || {});
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* saveRouteCode(action) {
   try {
      const data = yield call(postDataWithToken, SAVE_ROUTE_CODE_URL, action.data);
      if (action.onSuccess) {
         action.onSuccess();
      }
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Route Code Updated Successfully!"
      });
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* editHeadingCharges(action) {
   try {
      const data = yield call(putDataWithToken, [13,14,15].includes(action.rfqType) ? EXIM_EDIT_UPDATE_CHARGES_URL : EDIT_HEADING_CHARGES_URL, action.data);
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Heading Charges Updated Successfully!"
      });
      if(action.onSuccess) {
         action.onSuccess();
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* deleteAddedTrip (action) {
   try {
      yield put({
         type: DELETE_ADDED_TRIP_START
      })
      const data = yield call(deleteDataWithToken, ADDED_TRIP_DELETE_URL, '', action.data);
      yield call(getTrips,  { params: action.params });
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Data Deleted Successfully!"
      });
      yield put({
         type: DELETE_ADDED_TRIP_END
      })
   } catch(e) {
      yield put({
         type: DELETE_ADDED_TRIP_END
      })
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
} 

export function* getCourierTrips(action) {
   try {

      yield put({
         type: GET_COURIER_TRIPS_START
      });

      const data = yield call(getDataWithToken, GET_COURIER_TRIPS_URL, action.params);
      if (data.data && data.data.list) {
         let trips = '';
         const masterZones = (action.zones || []).map(zone => zone.name);
         let colZones = [];
         let rowZones = [];
         if(data.data && data.data.list && data.data.list.length > 0) {
            const tempRow = data.data.list.map(zone => zone.zone_name).filter((value) => !masterZones.includes(value));
            rowZones = [...masterZones , ...tempRow];
            trips = data.data.list.map((trip) => {
               return new CourierTrip(trip);
            })
            if(trips[0] && trips[0].zone_list &&  trips[0].zone_list.length > 0) {
               const tempCol = (trips[0].zone_list || []).map(zone => zone.zone_to).filter((value) => !masterZones.includes(value));
               colZones = [...masterZones, ...tempCol];
            }
         } else {
            trips = (action.zones || []).map((zone) => {
               return new CourierTrip('', action.zones, zone.name);
            })
            colZones = [...masterZones];
            rowZones = [...masterZones];
         }
         yield put({
            type: GET_COURIER_TRIPS_SUCCESS,
            trips: trips || [],
            tripsCount: data.data.trips_count,
            otherCharges: data && data.data && data.data.other_charges_list || [],
            rowZones: (rowZones || []).map(zone => ({ name: zone })) || [],
            additionalZones: data && data.data && data.data.additional_zone_list || [],
            colZones: (colZones || []).map(zone => ({ zone_to: zone})) || []
         });
         if (action.onSuccess) {
            action.onSuccess(data.data);
         }
      }
      yield put({
         type: SET_SYSTEM_TIME,
         data: data.system_time
      });
   } catch (e) {
      yield put({
         type: GET_COURIER_TRIPS_SUCCESS,
         trips: [],
         tripsCount:0,
         otherCharges: [],
         rowZones: [],
         additionalZones: []
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* postCourierTrips(action) {
   try {
      yield put({
         type: GET_COURIER_TRIPS_START
      });

      const data = yield call(postDataWithToken, POST_COURIER_TRIPS_URL, action.data);

      if(action.onSuccess) {
         action.onSuccess();
      }

   } catch(e) {

      yield put({
         type: POST_COURIER_TRIPS_END
      });

      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* courierPostBid(action) {
   try {
      yield put({
         type: POST_BID_SUBMITTING
      });
      const data = yield call(postDataWithToken, COURIER_POST_BID_URL, action.params);
      yield put({
         type: (data.status === 400) ? TOAST_ERROR : TOAST_SUCCESS,
			duration: 6,
         message: data && data.message ? data.message : "Bid Posted Successfully!"
      });
      if (action.onSuccess) {
         action.onSuccess(data.data);
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         duration: 6,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* getServiceCategory(action) {
   try {
      yield put({
         type: GET_SERVICE_CATEGORY_START
      });

      const data = yield call(getDataWithToken, GET_SERVICE_CATEGORY_URL, action.params);

      yield put({
         type: SAVE_SERVICE_CATEGORY,
         data: data && data.data || []
      })

      yield put({
         type: GET_SERVICE_CATEGORY_END
      })

   } catch(e) {
      yield put({
         type: GET_SERVICE_CATEGORY_END
      })
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });

   }
}

export function* updateServiceCategory(action) {
   try {

      yield put({
         type: GET_SERVICE_CATEGORY_START
      });

      const data = yield call(putDataWithToken, POST_SERVICE_CATEGORY_URL, action.data);
      
      if(action.onSuccess) {
         action.onSuccess();
      }

      yield put({
         type: GET_SERVICE_CATEGORY_END
      })

   } catch(e) {
      yield put({
         type: GET_SERVICE_CATEGORY_END
      })
      if(action.onError) {
         action.onError();
      }
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });

   }
}

export function* getTransporterBidCommonCharges(action) {
   try{

      yield put({
         type: GET_TRANSPORTER_BID_COMMON_CHARGES_CLEAR
      });

      const data = yield call(getDataWithToken, GET_TRANSPORTER_BID_COMMON_CHARGES_URL, action.params);

      yield put({
         type: SAVE_TRANSPORTER_BID_COMMON_CHARGES,
         data: data.data && data.data.list || []
      })
      // yield put({
      //    type: GET_TRANSPORTER_BID_COMMON_CHARGES_SUCCESS
      // })

   } catch(e) {
      console.log(e);
      yield put({
         type: GET_TRANSPORTER_BID_COMMON_CHARGES_SUCCESS
      })
   }
}


export function* downloadAuditTrailFormInfo(action) {
   try {
      const data = yield call(getDataWithToken, DOWNLOAD_AUDIT_TRAIL_FORM_DATA_URL, action.data);
		const presignedUrlData = yield call(getPresignedUrl, {
         data,
      });
      if (action.onSuccess) {
         action.onSuccess(presignedUrlData);
      }
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Downloaded File Successfully!"
      });
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* downloadMarketSiteRateInfo(action) {
   try {
      const data = yield call(getDataWithToken, DOWNLOAD_MARKET_SITE_RATE_DIFF_URL, action.data);
      const presignedUrlData = yield call(getPresignedUrl, {
         data,
      });
      if (action.onSuccess) {
         action.onSuccess(presignedUrlData);
      }
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Downloaded File Successfully!"
      });
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* getLocationWithPincode(action) {
   try {
      const data = yield call(getDataWithToken, GET_LOCATION_WITH_PINCODE_URL, action.data);
      yield put({
         type: AUTO_SUGGEST_LOCATIONS_DATA,
         data: data.data
      })
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* getDieselPriceDetails(action) {
   try {
      const data = yield call(getDataWithToken, DIESEL_PRICE_HIKE_URL, action.data);;
      if (action.onSuccess) {
         action.onSuccess(data && data.data || {});
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* getSAPRouteCodes(action) {
   try {
      const data = yield call(getDataWithToken, GET_SAP_ROUTE_CODES_URL, action.data);
      yield put({
         type: AUTO_SUGGEST_LOCATIONS_DATA,
         data: data.data
      })
      if (action.onSuccess) {
         action.onSuccess(data.data);
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* createFreshEvent(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(postDataWithToken, CREATE_EVENT_URL, action.data);
      yield put({
         type: END_LOADER
      });
      const event = transformRfq(data.data);
      localStorage.setItem('teg-component', true);
      location.href = "/event/create/" + event.event_id + "/" + event.id;
      
   } catch (e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* getRFQEvent(action) {
   try {
      const data = yield call(getDataWithToken, GET_RFQ_EVENT_URL, action.params);
      yield put({
         type: SET_SYSTEM_TIME,
         data: data.system_time
      });
      const rfq = transformRfq((data.data && (data.data || {}).event_rfq || {}));
      if(action.onSuccess) {
         action.onSuccess(rfq);
      }
      yield put({
         type: GET_RFQ_DETAIL_SUCCESS,
         rfq,
         eventDetails : {
            ...data.data
         }
      });
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* cancelEvent(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(putDataWithToken, CANCEL_EVENT_URL, action.data);
      if(action.onSuccess) {
         action.onSuccess();
      }
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Event Canceled Successfully!"
      })
      yield put({
         type: END_LOADER
      });
   } catch (e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* postEventDetails(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(postDataWithToken, CREATE_EVENT_URL, action.data);
      yield put({
         type: END_LOADER
      });
      if(action.status === 1) {
         yield put({
            type: TOAST_SUCCESS,
            message: data && data.message ? data.message : "Event Saved Successfully!"
         });
      }
      localStorage.setItem('teg-component', true);
      if(action.status === 2) {
         location.href = "/uploadRFQ/" + action.data.event_id + "/" + action.data.rfq_id; 
      }
   } catch(e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* postWishlistEvent(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(putDataWithToken, POST_WISHLIST_URL, action.data);
      if(action.onSuccess) {
         action.onSuccess();
      }
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Event Saved Successfully!"
      });
      yield put({
         type: END_LOADER
      });
   } catch(e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* updateRFQLevelVendorBiddingStatus(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(putDataWithToken, UPDATE_RFQ_LEVEL_VENDOR_BIDDING_STATUS_URL, action.data);
      if(action.onSuccess) {
         action.onSuccess();
      }
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Event Saved Successfully!"
      });
      yield put({
         type: END_LOADER
      });
   } catch(e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
} 

export function* uploadContainerTrips(action) {
   try {
      yield put({
         type: UPLOAD_TRIPS_SUBMITTING
      });

      const data = yield call(uploadFileWithSyncCalls, UPLOAD_CONTAINER_TRIPS_URL, action.file, action.params);
      yield put({
         type: UPLOAD_TRIPS_SUCCESS
      });
      yield put({
         type: TOAST_SUCCESS,
         message: data.message
      });
      if (action.onSuccess) {
         action.onSuccess(data.data);
      }
   } catch (e) {
      yield put({
         type: UPLOAD_TRIPS_SUCCESS
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}


export function* uploadExistingTripsRemarks(action) {
   try{
      yield put({
         type: UPLOAD_TRIPS_SUBMITTING
      });
      const data = yield call(uploadFileWithSyncCalls, UPLOAD_EXTISTING_TRIPS_REMARKS_URL, action.file, action.params);
      yield put({
         type: UPLOAD_TRIPS_SUCCESS
      });
      yield put({
         type: TOAST_SUCCESS,
         message: data.message
      });
      if (action.onSuccess) {
         action.onSuccess(data.data);
      }
   } catch (e) {
      yield put({
         type: UPLOAD_TRIPS_SUCCESS
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}


export function* downloadExistingTripsRemarks(action) {
   try {
      const data = yield call(getDataWithToken, DOWNLOAD_EXTISTING_TRIPS_REMARKS_TEMPLATE_URL, action.params);
      const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
      if (data && presignedUrlData.url) {
         downloadUrl(presignedUrlData?.url);
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* downloadContainerTripsTemplate(action) {
   try {
      const data = yield call(getDataWithToken, DOWNLOAD_CONTAINER_TEMPLATE_URL, action.params);
      const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
      if(presignedUrlData) {
         downloadUrl(presignedUrlData && presignedUrlData.url);
      }
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Downloaded File Successfully!"
      });
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* getContainerTrips(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(getDataWithToken, GET_CONTAINER_TRIPS_URL, action.params);
      if(action.onSuccess) {
         action.onSuccess(data && (data.data || {}).list || []);
      }
      yield put({
         type: END_LOADER
      });
   } catch(e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}


export function* postContainerTrips(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(postDataWithToken, POST_CONTAINER_TRIPS_URL, action.data);
      if(action.onSuccess) {
         action.onSuccess();
      }
      yield put({
         type: END_LOADER
      });
   } catch(e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* getConatinerLPP(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(postDataWithToken, POST_CONTAINER_LPP_URL, action.data);
      if(action.onSuccess) {
         action.onSuccess(data && data.data || {});
      }
      yield put({
         type: END_LOADER
      });
   } catch(e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}


export function* downloadUploadedFile(action) {
      action.param.companyId = action.param.companyId ? action.param.companyId : getUser().companyId;
   try {
      const data = yield call(getDataWithToken, DOWNLOAD_FILE_URL, action.param);
      if(data && data.url) {
         const link = document.createElement('a');
         link.href = data.url;
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
      }
   } catch (e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

const getAddTripUrl = (type) => {
   let addTripUrl = ADD_TRIP_URL;
   if(isAdaniWilmar() && type == 3) {
      addTripUrl = SEC_AWL_ADD_TRIP_URL;
   } else if(type === 9) {
      addTripUrl = POST_DISPOSAL_MATERIAL_TRIPS_URL;
   } else if([13,14,15].includes(type)) {
      addTripUrl = EXIM_ADD_TRIP_URL;
   } else if(type == 8) {
      addTripUrl = GENERAL_PROCUREMENT_ADD_TRIP_URL;
   }
   return addTripUrl;
}

const getTripsUrl = (whoami, type) => {
   let tripUrl = '';
   if(whoami && whoami === TRANSPORTER) {
      tripUrl = GET_TRIPS_TRANSPORTER_URL;
   } else if((type === 9 && !(whoami && whoami === TRANSPORTER))) {
      tripUrl = GET_DISPOSAL_MATERIAL_TRIPS_URL;
   } else if([13,14,15].includes(type)) {
      tripUrl = GET_EXIM_TRIPS_URL;
   } else if(type == 8) {
      tripUrl = GET_PROCUREMENT_TRIPS_URL
   } else {
      tripUrl = GET_TRIPS_URL;
   }
   return tripUrl;
}

const getPostBidUrl = (type) => {
   let postUrl = POST_BID_URL;
   if(type === 9) {
      postUrl = POST_DISPOSAL_PRODUCT_BID_URL;
   } else if([13,14,15].includes(type)) {
      postUrl = EXIM_POST_BID_URL;
   }
   return postUrl;
}

export function* getEximLppDetails(action) {
   try {
      const data = yield call(postDataWithToken, GET_EXIM_LPP_URL, action.data);
      if(action.onSuccess) {
         action.onSuccess(data && data.data || {})
      }
   } catch(e) {
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}

export function* getTermsAndConditions(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(getDataWithToken, GET_TERMS_AND_CONDITIONS_URL, action.params);
      if(action.onSuccess) {
         action.onSuccess(data && (data.data || {}).list || []);
      }
      yield put({
         type: END_LOADER
      });
   } catch(e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}


export function* postTollTaxUpdatePrice(action) {
  try {
    const data = yield call(postDataWithToken, POST_TOLL_TAX_UPDATE_PRICE_URL, action.data);
    if (action.onSuccess) {
      action.onSuccess((data && data.data) || {});
    }
    yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Downloaded File Successfully!"
      });
  } catch (e) {
    yield put({
      type: TOAST_ERROR,
      message: e && e.message ? e.message : "Oops! Something Went Wrong",
    });
  }
}


export function* downloadUploadedPreSignedFile(action) {
  action.param.companyId =
    action.param.companyId || getUser().companyId;

  try {
    const data = yield call(
      getDataWithToken,
      DOWNLOAD_FILE_URL,
      action.param
    );

    if (data?.url) {
      if (action.onSuccess) {
        action.onSuccess(data.url);
      }

      if (!action.skipDownload) {
        const link = document.createElement('a');
        link.href = data.url;
        link.download = ''; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  } catch (e) {
    yield put({
      type: TOAST_ERROR,
      message:
        e?.message || 'Oops! Something Went Wrong',
    });
  }
}

export function* getDphDashboardData(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(getDataWithToken, GET_DPH_DASHBOARD_LIST_URL, action.params);
      if(action.onSuccess) {
         action.onSuccess(data && (data.data || {}).list || []);
      }
      yield put({
         type: END_LOADER
      });
   } catch(e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* getDphBranchList(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(getDataWithToken, GET_DPH_BRANCHES_LIST_URL, action.params);
      if(action.onSuccess) {
         action.onSuccess(data && (data.data || {}).list || []);
      }
      yield put({
         type: END_LOADER
      });
   } catch(e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* postDphSendToApproval(action) {
  try {
    yield put({
         type: START_LOADER
      });
    const data = yield call(postDataWithToken, POST_DPH_SEND_TO_APPROVAL_URL, action.data);
    if (action.onSuccess) {
      action.onSuccess((data && data.data) || {});
    }
   
    yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Downloaded File Successfully!"
      });
    yield put({
         type: END_LOADER
      });
  } catch (e) {
    yield put({
      type: TOAST_ERROR,
      message: e && e.message ? e.message : "Oops! Something Went Wrong",
    });
  }
}

export function* updateDphCalculationMaster(action) {
  try {
    yield put({ type: START_LOADER });
    const data = yield call(postDataWithToken, UPDATE_DPH_CALCULATION_MASTER_URL, action.data);
    if (action.onSuccess) {
      action.onSuccess((data && data.data) || {});
    }
    yield put({
      type: TOAST_SUCCESS,
      message: data && data.message ? data.message : "DPH updated successfully!"
    });
    yield put({ type: END_LOADER });
  } catch (e) {
    yield put({
      type: TOAST_ERROR,
      message: e && e.message ? e.message : "Oops! Something Went Wrong"
    });
  }
}

export function* downloadDphCalculationMaster(action) {
  try {
    yield put({ type: START_LOADER });
    const data = yield call(getDataWithToken, DOWNLOAD_DPH_CALCULATION_MASTER_URL, action.params);
    const presignedUrlData = yield call(getPresignedUrl, { data });
    if (action.onSuccess) {
      action.onSuccess(presignedUrlData);
    }
    yield put({ type: END_LOADER });
  } catch (e) {
    yield put({ type: END_LOADER });
    yield put({
      type: TOAST_ERROR,
      message: e && e.message ? e.message : "Oops! Something Went Wrong"
    });
  }
}

export function* uploadDphCalculationMaster(action) {
  try {
    yield put({ type: START_LOADER });
    const data = yield call(uploadFileWithSyncCalls, UPLOAD_DPH_CALCULATION_MASTER_URL, action.file, action.params);
    const counts = (data && data.data) || {};
    const baseMsg = (data && data.message) ? data.message : "DPH uploaded successfully!";
    const countMsg = `Success: ${counts.success_count ?? 0}, Failed: ${counts.fail_count ?? 0}`;
    yield put({
      type: TOAST_SUCCESS,
      message: `${baseMsg} | ${countMsg}`
    });
    if (action.onSuccess) {
      action.onSuccess(data && data.data);
    }
    yield put({ type: END_LOADER });
  } catch (e) {
    yield put({ type: END_LOADER });
    yield put({
      type: TOAST_ERROR,
      message: e && e.message ? e.message : "Oops! Something Went Wrong"
    });
  }
}

export function* getDphRfqDetailsData(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(getDataWithToken, GET_DPH_RFQ_DETAILS_URL, action.params);
      if(action.onSuccess) {
         action.onSuccess(data && (data.data || {}));
      }
      yield put({
         type: END_LOADER
      });
   } catch(e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* postDphApproveRejectProposal(action) {
  try {
   yield put({
         type: START_LOADER
      });
    const data = yield call(postDataWithToken, POST_DPH_APPROVE_REJECT_PROPOSAL_URL, action.data);
    if (action.onSuccess) {
      action.onSuccess((data && data.data) || {});
    }
    yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Downloaded File Successfully!"
      });
   yield put({
         type: END_LOADER
      });
  } catch (e) {
    yield put({
      type: TOAST_ERROR,
      message: e && e.message ? e.message : "Oops! Something Went Wrong",
    });
  }
}

export function* postUpdateBusinessVolume(action) {
  try {
   yield put({
         type: START_LOADER
      });
    const data = yield call(postDataWithToken, POST_UPDATE_BUSINESS_VOLUME_URL, action.data);
    if (action.onSuccess) {
      action.onSuccess((data && data.data) || {});
    }
    yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "Downloaded File Successfully!"
      });
   yield put({
         type: END_LOADER
      });
  } catch (e) {
    yield put({
      type: TOAST_ERROR,
      message: e && e.message ? e.message : "Oops! Something Went Wrong",
    });
  }
}

export function* getDphApproverDetails(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(getDataWithToken, GET_DPH_APPROVER_DETAILS_URL, action.params);
      if(action.onSuccess) {
         action.onSuccess(data && (data.data || {}));
      }
      yield put({
         type: END_LOADER
      });
   } catch(e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* getDphDownloadExcel(action) {
   try {
      yield put({
         type: START_LOADER
      });
      const data = yield call(getDataWithToken, GET_DPH_DOWNLOAD_EXCEL_URL, action.params);
      if(action.onSuccess) {
         action.onSuccess(data && data.message);
      }
      yield put({
         type: END_LOADER
      });
   } catch(e) {
      yield put({
         type: END_LOADER
      });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      })
   }
}

export function* adminUpdateRFQ(action) {
   try {
      yield put({ type: START_LOADER });
      const data = yield call(putDataWithToken, ADMIN_UPDATE_RFQ_URL, action.data);
      yield put({ type: ADMIN_UPDATE_RFQ_SUCCESS });
      yield put({
         type: TOAST_SUCCESS,
         message: data && data.message ? data.message : "RFQ updated successfully!"
      });
      if (action.onSuccess) action.onSuccess(data);
      yield put({ type: END_LOADER });
   } catch(e) {
      yield put({ type: END_LOADER });
      yield put({
         type: TOAST_ERROR,
         message: e && e.message ? e.message : "Oops! Something Went Wrong"
      });
   }
}
